// extracted by mini-css-extract-plugin
module.exports = {"betReceipt":"_6fe5f1e","content":"_3eec231","main":"_28f8db7","title":"_7dba2f2"};